import { useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import {
  useIsAdmin,
  useIsDocumentControl,
  useIsQHSE,
  useResolveRootRoles,
} from "../../utils/hooks";
import { useAuth } from "../../hooks/useAuth";

export default function RequisitionNav(props) {
  const { user: authUser } = useAuth();
  const isAdmin = useIsAdmin();
  const isDocumentControl = useIsDocumentControl();
  const isQhse = useIsQHSE();
  const { getRootRoles } = useResolveRootRoles();
  const items = useMemo(() => {
    const navItems = [
      ...(isAdmin || isDocumentControl || isQhse
        ? [
            {
              name: "Forms",
              to: "forms",
            },
          ]
        : []),
      {
        name: "Request and Approvals",
        to: "request",
      },
      ...(isAdmin
        ? [
            {
              name: "Fund Request Approval",
              to:
                "fund-request-approval?page=1&limit=40&q=&status=&type=Fund+Request&sortByDate=dateModified&FormID=&showAll=true",
            },
            {
              name: "System Forms",
              to: "system-form",
            },
          ]
        : []),
      {
        name: "Fill a Form",
        to: "fill-a-form",
      },
    ];

    return getRootRoles({
      navItems,
    });
  }, [isAdmin, authUser.Department, authUser.company]);

  return (
    <div className="dashboard-tabs innerpage-tabs px-4">
      <ul className="nav nav-tabs">
        {items.map((item, index) => (
          <li key={index} className="nav-item">
            <NavLink className={`nav-link ga-nav-tab`} to={item.to}>
              {item.name}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
}
